import has from 'lodash/has';
import set from 'lodash/set';

/**
 * This function is designed to take in an original object, and an updated object,
 * 	map over the original object's shape, and inject the updated object's values.
 * 	It returns a new object of the union of Original's shape, but Updated's contents.
 * @function CloneByCopy
 * @template T
 * @param {T} updated The new object to copy from.
 * @param {T} original The existing object, to use as a shape. If property is missing from updated, it will be omitted in the return as well.
 * @returns {T} A stripped and updated object.
 */
export function cloneByCopy(updated, original) {
	/** @type {T} */
	let ret = Object.assign({});

	// An extra safeguard to only iterate objects.
	if (typeof original !== 'object') {
		return original;
	}

	for (const key in original) {
		const val = original[key];

		// No original value, or no updated value - do nothing.
		if (val === null || val === undefined || !has(updated, key)) {
			continue;
		}

		let toSet;
		if (typeof val !== 'object') {
			toSet = updated[key];
		} else if (Array.isArray(val)) {
			toSet = val.map((v, i) => cloneByCopy(updated?.[key]?.[i], v));
		} else {
			toSet = cloneByCopy(updated[key], val);
		}

		// @ts-ignore - inside the 'forIn' method, we must already be an Object.
		set(ret, key, toSet);
	}

	return ret;
}
